import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageId, getImageUrl, getImageSize, convertEpochTime, getListButtonIcon,fetchAnchorValue, GetFallBackImage } from './../../common/utils';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// const DEFAULT_PLACEHOLDER = "https://static.toiimg.com/photo/42706777.gif";
import "./list.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  // console.log(props);
  const { showDateTime, showAuthorName, item, background, isSimilarStories, isViewport, anchorLinksValue } = props;

  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
      useEffect(()=>{
          EagerLoadImages()
      },[]);
  const { hl, syn, mobileView, au, imageid, pubInfo, wu, upd, tn, du } = item;
  const cache = getMUICache();
  let styles = require("./list.css");
  appendStyleSheet("ListView", styles);
 
  let imageSize = getImageSize(imageid);

  return (
    <CacheProvider value={cache}>
      <div>
        <div className='listcontainer'>
          <div className="mainlistingwrap" style={{ background: background }}>
            <a role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, wu)} className='listwrap'>
              <div className='listimage'>

                {isSimilarStories
                  ?
                  (imageSize && isViewport ? 
                  <img  alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} src={getImageUrl(getImageId(imageid), imageSize, 130, undefined, pubInfo.baseDomain, false, props.CONSTANTS, '3')} loading="lazy" /> 
                  : (imageSize && !isViewport ? <img  alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} src={getImageUrl(getImageId(imageid), imageSize, 130, undefined, pubInfo.baseDomain, false, props.CONSTANTS, '8')} loading="lazy" /> : null))
                  :
                  (imageSize && 
                    (<picture>
                      {/* Add multiple source elements for different image sources */}
                      <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 220, 165, pubInfo.baseDomain, false, props.CONSTANTS)} />
                      <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 112, 84, pubInfo.baseDomain, false, props.CONSTANTS)} />
                      {/* Fallback image for browsers that do not support the picture element */}
                      {isViewport ? (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)
                      : (
                      
                      <img src={GetFallBackImage()} alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                      )}
                    </picture>))
                }

                {(tn == "MEDIAAUDIO" || tn == "MEDIAVIDEO") &&
                  <div className='optionaliconswrap'>
                    <span className='commonhandalebutton'>{getListButtonIcon(tn)}</span> <span className='videodu'> {du} Mins</span>
                  </div>
                }
              </div>
              <div className='listcontent-wrap'>
                <div className={`block-wrapper ${mobileView ? "mwebView" : ""}`}>
                  <div className="card_details">
                    <h4 className="subheading">{hl}</h4>
                    <div className='publisherdetailwrap'>
                      {showAuthorName && <span className='commonset desktopauthor'>{au}</span>}
                      {/* <span className='platformname'>ANI</span> */}
                      {showDateTime && <span className='commonset updatedate'>{convertEpochTime(upd, 'updated', "DD MMM YYYY")}</span>}
                    </div>
                    <p className='listcontent-text'>{syn}</p>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className='clearfix'></div>
        </div>
      </div>
    </CacheProvider>
  )
}
export default Card;